import Company from "@/views/company/Company.vue";
import CategoriesList from "@/superUp-module/resources/views/pages/category/List.vue";
import LabelsList from "@/superUp-module/resources/views/pages/labels/List.vue";
import Widget from "@/superUp-module/resources/views/pages/widget/Widget.vue";

export default {
    router: [
        {
            path: '/up-mobil-plus',
            component: Company,
            children: [
                //widget
                {
                    path: 'widget',
                    component: Widget,
                    name: "up_mobil_plus_widget",
                    meta: {
                        menu: 'up_mobil_plus_widget',
                        parent: 'up_mobil_plus'
                    },
                },
                {
                    path: 'campaigns-categories',
                    component: CategoriesList,
                    name: "up_mobil_plus_categories",
                    meta: {
                        menu: 'up_mobil_plus_categories',
                        parent: 'up_mobil_plus'
                    },
                },
                {
                    path: 'sub-categories',
                    component: LabelsList,
                    name: "up_mobil_plus_labels",
                    meta: {
                        menu: 'up_mobil_plus_labels',
                        parent: 'up_mobil_plus'
                    }
                }
            ],
        }
    ]
}